import { Avatar, Group, Menu, Stack, Text, UnstyledButton } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import cx from 'clsx';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useChangeCurrentRole } from '@/module/Security/model/SecurityQuery';

import { RoleType, useCurrentUser } from '@feature/security';
import { useAppNotification } from '@feature/utils';

import classes from './styles/ProfileMenu.module.css';

export function ProfileMenu() {
  const [userMenuOpened, setUserMenuOpened] = useState(false);
  const { lastName, firstName, currentRole, availableRoles } = useCurrentUser();
  const { t } = useTranslation();
  const name = `${lastName} ${firstName}`;
  const { mutate } = useChangeCurrentRole();
  const notification = useAppNotification();

  const navigate = useNavigate();
  const onRoleChange = (newRole: RoleType) => {
    mutate(newRole, {
      onError: notification.error,
      onSuccess: () => {
        notification.success();
        navigate({ to: '/' });
      },
    });
  };

  return (
    <Menu
      width={260}
      position="bottom-end"
      transitionProps={{ transition: 'pop-top-right' }}
      onClose={() => setUserMenuOpened(false)}
      onOpen={() => setUserMenuOpened(true)}
      withinPortal
    >
      <Menu.Target>
        <UnstyledButton className={cx(classes.user, { [classes.userActive]: userMenuOpened })}>
          <Group gap={7}>
            <Stack
              gap="2px"
              align="flex-end"
            >
              <Text
                size="sm"
                lh={1}
                mr={3}
              >
                {name}
              </Text>
              <Text
                size="sm"
                lh={1}
                mr={3}
                c="grey"
              >
                {t(`roleType.${currentRole}`)}
              </Text>
            </Stack>
            <Avatar
              alt={name}
              radius="xl"
              size={35}
            />
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>Roluri</Menu.Label>
        {(availableRoles ?? []).map(role => (
          <Menu.Item
            key={role}
            component="button"
            onClick={() => onRoleChange(role)}
          >
            {t(`roleType.${role}`)}
          </Menu.Item>
        ))}
        <Menu.Divider />
        <Menu.Label>Acțiuni</Menu.Label>
        <Menu.Item
          component="a"
          href="/login"
        >
          Logout
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
